import axios from "axios";

export const _getCreditCharges = async (page, size) => {
  try {
    const url = `/credit-charges?page=${page}&pageSize=${size}`;
    const response = await axios.get(url);
    return response;
  } catch (error) {
    throw error;
  }
};

export const _getCreditChargeById = async (id) => {
  try {
    const url = `/credit-charge/${id}`;
    const response = await axios.get(url);
    return response;
  } catch (error) {
    throw error;
  }
};

export const _createCreditCharge = async (data) => {
  try {
    const url = `/credit-charge`;
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const _updateCreditCharge = async (id, data) => {
  try {
    const url = `/credit-charge/${id}`;
    const response = await axios.put(url, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const _deleteCreditCharge = async (id) => {
  try {
    const url = `/credit-charge/${id}`;
    const response = await axios.delete(url);
    return response;
  } catch (error) {
    throw error;
  }
};
